import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import ContactButton from "../components/ContactButton.jsx";
import ProgressiveImage from "react-progressive-graceful-image";
import images from "../theme/images.js";
import HomeStats from "../components/HomeStats.jsx";
import { Link } from "react-router-dom";
import { useScrollTop } from "../utils/useScrollTop.js";

export default function Home() {
	useScrollTop();
	const { t } = useTranslation();
	const [counterCanStart, setCounterCanStart] = useState(false);

	return (
		<div id='home-container'>
			<div className='hero-section' id='home-hero'>
				<div className='hero-image-container' id='image-1-container'>
					<ProgressiveImage
						src={require("../assets/tamplarie-pvc.jpg")}
						placeholder={require("../assets/tamplarie-pvc-placeholder.jpg")}
					>
						{(src, loading) => (
							<img
								src={src}
								className={`home-hero-image ${loading ? "loading" : "loaded"}`}
								alt='tamplarie pvc aluminiu'
								onLoad={() => setCounterCanStart(true)}
							/>
						)}
					</ProgressiveImage>
					<div className='hero-text-container'>
						<h1>{t("homepage.hero_pvc")}</h1>
					</div>
				</div>

				<div className='hero-image-container' id='image-2-container'>
					<ProgressiveImage
						src={require("../assets/mobila.jpg")}
						placeholder={require("../assets/mobila-placeholder.jpg")}
					>
						{(src, loading) => (
							<img
								src={src}
								className={`home-hero-image ${loading ? "loading" : "loaded"}`}
								alt='mobila mdf pal'
							/>
						)}
					</ProgressiveImage>
					<div className='hero-text-container'>
						<h1>{t("homepage.hero_lemn")}</h1>
					</div>
				</div>
			</div>

			<div className='home-section about-us'>
				<img src={images.logo_sign} alt={"ThermoArt Design logo"} />
				<h2 className='section-title'>{t("homepage.about_us")}</h2>
				<p>{t("homepage.about_us_content")}</p>
			</div>

			<HomeStats counterCanStart={counterCanStart} />

			<div className='home-section discover-us'>
				<h2 className='section-title'>{t("homepage.discover")}</h2>
				<p>{t("homepage.discover_content")}</p>
				<ContactButton text={t("interface.wantOffer")} />
			</div>
			
			<div className='home-section see-products'>
				<div className="separator" />
				<p>{t('homepage.see_products')}</p>
				<Link
					className="see-more-link"
					to={'/album'}
				>
					{t('interface.seeProducts')}
				</Link>
			</div>
		</div>
	);
}
